import React from 'react';
import { PropTypes } from 'prop-types';

import {
  Row, Col, DatePicker, Table, Popconfirm, Button,
} from 'antd';
import { CheckCircleOutlined, SendOutlined } from '@ant-design/icons';

const { RangePicker } = DatePicker;

const SettlementReportSummary = ({
  summary,
  summaryLoading,
  handleChange,
  markAsSettled,
  isUpdating,
  currencyAsSettled,
  sendSettlementSummary,
}) => {
  const props = {
    loading: summaryLoading,
    pagination: false,
    rowKey: 'currency',
    columns: [
      {
        title: 'Currency',
        dataIndex: 'currency',
      },
      {
        title: 'Settled Amount',
        dataIndex: 'settledAmount',
        render: (value) => new Intl.NumberFormat().format(value),
      },
      {
        title: 'Unsettled Amount',
        dataIndex: 'unsettledAmount',
        render: (value) => new Intl.NumberFormat().format(value),
      },
      {
        title: '',
        dataIndex: '',
        render: (value, record) => (
          <>
            <Popconfirm title="Sure all amount was settled?" onConfirm={() => markAsSettled(record)}>
              <Button
                type="warning"
                title="Mark As settled"
                loading={isUpdating && currencyAsSettled === record.currency}
                icon={<CheckCircleOutlined />}
              />
            </Popconfirm>
            <Popconfirm title="Sure ?" onConfirm={() => sendSettlementSummary(record)}>
              <Button
                type="warning"
                title="Send Settlement Summary"
                loading={isUpdating && currencyAsSettled === record.currency}
                icon={<SendOutlined />}
              />
            </Popconfirm>
          </>
        ),
      },
    ],
    dataSource: summary,
  };

  return (
    <>
      <div>
        <RangePicker onChange={(_, dateString) => handleChange(dateString, 'date_range')} style={{ width: '100%' }} />
      </div>
      <Row>
        <Col xl={24} lg={24} md={24} sm={24} xs={24}>
          {summaryLoading
          && <span>loading... </span>}
        </Col>
      </Row>
      {!summaryLoading && summary && summary?.length > 0
      && (
        <div>
          <Table className="gx-table-responsive" {...props} />
        </div>
      )}
    </>
  );
};

SettlementReportSummary.propTypes = {
  summary: PropTypes.oneOfType([
    PropTypes.any,
  ]),
  summaryLoading: PropTypes.bool,
  isUpdating: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
  markAsSettled: PropTypes.func.isRequired,
  sendSettlementSummary: PropTypes.func.isRequired,
  currencyAsSettled: PropTypes.string,
};

SettlementReportSummary.defaultProps = {
  summary: null,
  summaryLoading: false,
  isUpdating: false,
  currencyAsSettled: null,
};

export default SettlementReportSummary;
